import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 100%;

  .ant-tabs {
    height: 100%;
  }
  .ant-tabs-nav {
    margin: 0 !important;
  }
  .ant-tabs .ant-tabs-content {
    height: 100%;
    padding: 16px;
  }
  .ant-tabs .ant-tabs-tabpane {
    height: 100%;
  }
`;

export const TitleWrapper = styled.div`
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 12px;
`;
